import { AttributeType } from './models';

export const attributeTypeToOperators: Record<AttributeType, string[]> = {
  string: ['equal', 'notEqual'],
  number: ['equal', 'notEqual', 'lessThan', 'lessThanInclusive', 'greaterThan', 'greaterThanInclusive'],
  array: ['contains', 'doesNotContain', 'in', 'notIn' ,'some' ,'every'],
};

export function isArrayOperator(op: string): boolean {
  return op === 'in' || op === 'notIn' || op === 'some' || op === 'every';
}


